export function initMenuToggle() {
    const $mobileHeader = $('header .mobile-nav').first();
    const $mobileHeaderLinks = $('#mobile-header-links');
    const $icon = $('#menu-toggle i');
    const $menuToggleLinks = $('#mobile-links-nav a');
    const $menuToggle = $('#menu-toggle');
    const $menuToggleLogoLg = $('#rv-logo-lg');
    const $menuToggleLogoSm = $('#rv-logo-sm');
    const $formContainerMobile = $('.form-container-mobile');
  
    function toggleMenuState(isActive) {
      $mobileHeaderLinks.toggleClass('d-none', !isActive);
      $menuToggleLinks.toggleClass('d-none', isActive);
      $icon.toggleClass('icon-close', isActive);
      $icon.toggleClass('icon-hamburger', !isActive);
      $icon.toggleClass('clr-raspberry', !isActive);
      $icon.toggleClass('toggle-btn', isActive);
      $menuToggle.toggleClass('bg-transparent', !isActive);
      $menuToggle.toggleClass('active', isActive);
      $menuToggleLogoLg.toggleClass('d-none', !isActive);
      $menuToggleLogoSm.toggleClass('d-none', isActive);
      $formContainerMobile.toggleClass('d-none', isActive);
    }
  
    $menuToggle.on('click', function (e) {
      e.preventDefault();
      const isActive = !$mobileHeader.hasClass('is-active');
      $mobileHeader.toggleClass('is-active', isActive);
      toggleMenuState(isActive);
    });
  
    $(document).on('click', function (e) {
      if (
        $mobileHeader.hasClass('is-active') &&
        !$mobileHeader.is(e.target) &&
        !$menuToggle.is(e.target) &&
        $mobileHeader.has(e.target).length === 0 &&
        $menuToggle.has(e.target).length === 0
      ) {
        $mobileHeader.removeClass('is-active');
        toggleMenuState(false);
      }
    });
  
    $menuToggle.css({ 'pointer-events': 'auto', 'z-index': 1000 });
    $icon.css({ 'pointer-events': 'auto', 'z-index': 1001 });
  }